import React from 'react';

import get from 'lodash/get';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import { Controller } from 'react-hook-form';

import { LabelTooltip } from '@src/components/ui/Tooltip';

const HookFormTextInput = (props) => {
    const { name, label, isRequired, control, errors, type, title, className } = props;

    return (
        <Form.Group className={`mb-3 col w-100 floating-label ${className || ''}`} xs={12} sm={6} md={6} controlId={name}>
            <Form.Label>
                { isRequired && <abbr title="required">*</abbr> }
                {' '}
                { label }
                { title && <LabelTooltip title={title} /> }
            </Form.Label>
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <Form.Control
                        {...field}
                        value={field.value ?? ''}
                        className="w-100"
                        type={type}
                        isInvalid={Boolean(errors[name])}
                    />
                )}
            />
            {
                Boolean(get(errors, [name, 'message'])) && (
                    <Form.Control.Feedback type="invalid" className="d-block">
                        { get(errors, [name, 'message']) }
                    </Form.Control.Feedback>
                )
            }
        </Form.Group>
    );
};

HookFormTextInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    control: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
};

export default HookFormTextInput;
